import { element } from 'angular';
export var CompareListEventsDirective = [
    'compareChannel',
    'compareListEvents',
    function (compareChannel, compareListEvents) {
        return {
            link: function ($scope, $element) {
                var compareItemHeight = 56;
                var compareProductsCount = compareChannel.get().length;
                $element.on('click', function (event) {
                    var newCompareProductsCount = compareChannel.get().length;
                    event.preventDefault();
                    event.stopPropagation();
                    if (newCompareProductsCount === 0) {
                        $scope.$destroy();
                        $element.remove();
                    }
                    else if (newCompareProductsCount !== compareProductsCount) {
                        var offset = $element.offset();
                        var headerHeight = element('header').height();
                        $element.css({
                            top: offset.top - headerHeight + compareItemHeight + 'px',
                        });
                        compareProductsCount = newCompareProductsCount;
                    }
                });
                $element.on('mouseenter', function () {
                    compareListEvents.cancelTimeouts();
                });
                $element.on('mouseout', function (event) {
                    var $target = element(event.relatedTarget);
                    var isInsideElement = $target.closest($element).length > 0;
                    event.preventDefault();
                    event.stopPropagation();
                    if (isInsideElement) {
                        return;
                    }
                    $element.remove();
                });
                $scope.$on('$destroy', function () {
                    compareListEvents.cancelTimeouts();
                    $element.off('click mouseout mouseenter');
                });
            },
            restrict: 'A',
        };
    },
];
